import apiClient from '@/services/api-client';

export default {
	GetCompanyNMLSAndBrokerId(
		userId,
		currentUserId,
		requestUserId,
		organizationId,
	) {
		return apiClient().post('/ProductAndPricing/GetCompanyNMLSAndBrokerId', {
			userId,
			currentUserId,
			requestUserId,
			organizationId,
		});
	},

	GetAddressDetails(zipcode) {
		return apiClient().post('/ProductAndPricing/GetAddressDetails', {
			zipcode,
		});
	},

	getProductAndPricing(params) {
		const args = {};

		Object.keys(params).forEach((key) => {
			const value = params[key];

			if (value !== null && value !== '') {
				args[`${key}`] = value;
			}
		});

		return apiClient().post('/ProductAndPricing/GetProductAndPricing', args);
	},

	canSeePricing(entityId) {
		return apiClient().post('/ProductAndPricing/CanSeePricing', {
			entityId,
		});
	},
};
